import { render, staticRenderFns } from "./ItemHalfWidth.vue?vue&type=template&id=39c01a2f&scoped=true"
import script from "./ItemHalfWidth.vue?vue&type=script&lang=js"
export * from "./ItemHalfWidth.vue?vue&type=script&lang=js"
import style0 from "./ItemHalfWidth.vue?vue&type=style&index=0&id=39c01a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c01a2f",
  null
  
)

export default component.exports